import { render, staticRenderFns } from "./ChatBotDataSrcList.vue?vue&type=template&id=25b4d642&scoped=true"
import script from "./ChatBotDataSrcList.vue?vue&type=script&lang=js"
export * from "./ChatBotDataSrcList.vue?vue&type=script&lang=js"
import style0 from "./ChatBotDataSrcList.vue?vue&type=style&index=0&id=25b4d642&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b4d642",
  null
  
)

export default component.exports